import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import HomeCards from 'components/HomeCards';

import fileSvg from '/file.svg';
import searchSvg from '/search.svg';
import converterSvg from '/converter.svg';
import mapSvg from '/map.svg';
import feasibilitySvg from '/feasibility.svg';
import optimizerSvg from '/optimizer.svg';

import useUser from 'api/hooks/useUser';
import Loading from 'components/Loading';
import useTranslationHome from 'api/hooks/useTranslationHome';

const Home = () => {
  const { t } = useTranslation();
  const { data: user, isPending } = useUser();
  const { data: translations, isPending: isPendingTranslation } =
    useTranslationHome(t);
  const isOffline = localStorage.getItem('netStatus') === 'offline';

  const contentArr = [
    {
      id: 1,
      icon: mapSvg,
      title: t('prospectMap'),
      text: translations?.prospectMap,
      routeToNavigate: isOffline ? '/prospect-map-offline' : '/prospect-map',
    },
    {
      id: 2,
      icon: fileSvg,
      title: t('industryBrief'),
      text: translations?.industryApplicationBrief,
      routeToNavigate: '/application-brief',
    },
    {
      id: 3,
      icon: converterSvg,
      title: t('converter'),
      text: translations?.productConverter,
      routeToNavigate: '/product-converter',
    },
    {
      id: 4,
      icon: feasibilitySvg,
      title: t('feasibility'),
      text: translations?.feasibilityCheck,
      routeToNavigate: '/feasibility-check',
    },
    {
      id: 5,
      icon: searchSvg,
      title: t('finder'),
      text: translations?.productFinder,
      routeToNavigate: '/product-finder',
    },
  ];

  const blueUser = user?.role?.id === 3;
  const greenUser = user?.role?.id === 4;
  const blueLightUser = user?.role?.id === 6;
  const allUser = user?.role?.id === 1 || user?.role?.id === 5;

  const bgImage = useMemo(() => {
    if (allUser) {
      return '/blueGreenHome.png';
    }

    if (blueUser || blueLightUser) {
      return '/blueHome.png';
    }

    if (greenUser) {
      return '/greenHome.png';
    }
  }, [user]);

  if (isPending || isPendingTranslation) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Loading size={50} color="#007AC1" />
      </div>
    );
  }

  const notBlueGreenLight = !blueUser && !greenUser && !blueLightUser;

  return (
    <div className=" w-screen relative mb-10">
      <img
        src={bgImage}
        alt=""
        className="md:h-[305px] w-full object-cover h-[240px]"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: -1,
        }}
      />
      <div className="px-[100px] md:px-[16px] md:pb-4">
        <div className="pt-[120px] grid gap-4 grid-cols-4 grid-rows-2 md:grid-cols-2 md:gap-3 md:pt-[70px]">
          {greenUser ? (
            <HomeCards
              icon={optimizerSvg}
              title={t('croptimizer')}
              text={translations?.crOptimizer}
              routeToNavigate="/croptimizer"
            />
          ) : blueLightUser ? (
            <>
              {contentArr.slice(1, 4).map((item) => (
                <HomeCards
                  key={item.id}
                  icon={item.icon}
                  title={item.title}
                  text={item.text}
                  routeToNavigate={item.routeToNavigate}
                />
              ))}
            </>
          ) : (
            <>
              {contentArr.map((item) => (
                <HomeCards
                  key={item.id}
                  icon={item.icon}
                  title={item.title}
                  text={item.text}
                  routeToNavigate={item.routeToNavigate}
                />
              ))}
            </>
          )}
        </div>
        {notBlueGreenLight && (
          <div className="h-px my-8 bg-[#E2E2E2] w-full md:my-4" />
        )}
        {notBlueGreenLight && (
          <div className="grid gap-4 grid-cols-4 grid-rows-1 md:grid-cols-2 md:gap-3 md:mt-2">
            <div className="">
              <HomeCards
                icon={optimizerSvg}
                title={t('croptimizer')}
                text={translations?.crOptimizer}
                routeToNavigate="/croptimizer"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
